/**
 * ATELIER LUXURY SHOPIFY THEME - GLOBAL JAVASCRIPT
 */

// --- Debounce Utility ---
function debounce(fn, wait) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

// --- Shopify Currency Formatter ---
window.formatMoney = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.themeSettings?.moneyFormat || '£{{amount}}';

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsPart = parts[1] ? decimal + parts[1] : '';

    return dollars + centsPart;
  }

  switch (formatString.match(placeholderRegex)?.[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};

// --- Global Toast Notification ---
window.showToast = function (message, duration = 3500) {
  const toast = document.getElementById('NotificationToast');
  if (!toast) return;
  const msgEl = toast.querySelector('.notification-toast__message');
  if (msgEl) msgEl.textContent = message;
  toast.hidden = false;
  setTimeout(() => {
    toast.hidden = true;
  }, duration);
};

// --- Mobile Navigation Drawer ---
document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const menuDrawer = document.getElementById('MobileMenuDrawer');
  const menuClose = document.querySelector('[data-mobile-menu-close]');

  if (menuToggle && menuDrawer) {
    menuToggle.addEventListener('click', () => {
      menuDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    const closeDrawer = () => {
      menuDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    if (menuClose) menuClose.addEventListener('click', closeDrawer);
    menuDrawer.querySelector('.mobile-menu__backdrop')?.addEventListener('click', closeDrawer);
  }

  // --- Modal Dialog Controller (Size Guide, etc.) ---
  document.querySelectorAll('[data-modal-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = trigger.getAttribute('data-modal-target');
      const modal = document.getElementById(targetId);
      if (modal) {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-modal-close]').forEach((closer) => {
    closer.addEventListener('click', () => {
      const modal = closer.closest('.modal-dialog');
      if (modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  });

  // Close modals on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal-dialog:not([hidden])').forEach((modal) => {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
      document.querySelector('.cart-drawer.is-open')?.classList.remove('is-open');
      document.querySelector('.predictive-search-modal.is-open')?.classList.remove('is-open');
      document.getElementById('MobileMenuDrawer')?.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  // --- Web Share API Component ---
  if (!customElements.get('share-button')) {
    customElements.define('share-button', class extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.message = this.querySelector('.share-button__message');
        if (this.button) {
          this.button.addEventListener('click', this.handleShare.bind(this));
        }
      }

      handleShare() {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: window.location.href
          }).catch(() => {});
        } else {
          navigator.clipboard.writeText(window.location.href).then(() => {
            if (this.message) {
              this.message.classList.remove('hidden');
              setTimeout(() => this.message.classList.add('hidden'), 2500);
            } else {
              window.showToast('Link copied to clipboard');
            }
          });
        }
      }
    });
  }
});
